function identity(o) {
  return o;
}

const retn = f => a => {
  f(a);
  return a;
};
const retm = f => (a, b) => {
  f(a, b);
  return a;
};
const reto = f => (a, b, c) => {
  f(a, b, c);
  return a;
};
const pushed = retm((a, v) => {
  a.push(v);
});
const pushedka = reto((a, k, v) => {
  a[k].push(v);
});
const set = reto((a, k, v) => (a[k] = v));
const always = v => () => v;

Array.prototype.groupBy = function(g) {
  return this.reduce(
    (d, e) => (k => (k in d ? pushedka(d, k, e) : set(d, k, [e])))(g(e)),
    {}
  );
}

const reentry = o => f =>
  Object.fromEntries(Object.entries(o).map(([i, e]) => f(i, e)));

function passthru(fn) {
  return v => {
    fn(v);
    return v;
  };
}

const thru = f => v => { f(v); return v }
const delay = (f,t=1000) =>
      new Promise ((r) => {
          setTimeout(() => { let v=f(); r(v) }, t)
      })


function keyed(k, fo, o, ko) {
  let _ = {};
  _[k] = fo(o);
  _[ko] = o;
  return _;
}

// const thru = passthru;

//        let pluck = (o, ks) => { (ks) ? o[k[0]] : o };
//        let deepfilter = (ks, f) => (xs) => {
//          xs.filter(o => f(pluck(o,ks)))
//        };
//        let constantly = (k) => () => k;

function clamp(v, a, b) {
  if (v < a) {
    return a;
  } else if (v > b) {
    return b;
  } else {
    return v;
  }
}

function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function updateinf(zero, selectors, valuer) {
  // assert zero is Object
  // reduce selectors to <final> then valuer(<final>)
  // let final = _.reduce(apply, selectors, zero)
  // valuer(final)
  return [zero, selectors, valuer];
}

function juxt(...fns) {
  return v => fns.map(f => f(v));
}

function suck(a, b, ...c) {
    for (let k in a) {
        a[k] = b[k]
    }
    for (let k of c) {
        a[k] = b[k]
    }
    return a
}

function randRange (a,b) {
    let p = Math.random()
    let d = b - a
    let r = p * d
    return a + r
}

export {
  retn,
  pushed,
  always,
  identity,
  reentry,
  passthru,
    delay,
  keyed,
  thru,
  uuidv4,
  clamp,
  updateinf,
  juxt,
    suck,
  randRange,
};
